'use client'

import { getAppKit, wagmiAdapter } from '@/config/appkit'
import { type ReactNode, useEffect, useState } from 'react'
import { type Config, WagmiProvider } from 'wagmi'

export function AppKitProvider({ children }: { children: ReactNode }) {
	const [ready, setReady] = useState(false)

	useEffect(() => {
		// Initialize AppKit on client
		getAppKit()
		setReady(true)
	}, [])

	if (!ready) return null

	return <WagmiProvider config={wagmiAdapter.wagmiConfig as Config}>{children}</WagmiProvider>
}
